import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
}
export const Card = ({ children }: CardProps) => <main className="card">{children}</main>;

interface CardHeadProps {
  sub?: ReactNode;
  right?: ReactNode;
}
export const CardHead = ({ sub, right }: CardHeadProps) => {
  if (!sub && !right) return null;
  return (
    <div className="card-head">
      {sub && <span className="sub">{sub}</span>}
      {right}
    </div>
  );
};

interface CardBodyProps {
  children: ReactNode;
}
export const CardBody = ({ children }: CardBodyProps) => <div className="body">{children}</div>;

interface FooterActionsProps {
  /** Left-aligned (e.g. "Back to Images") action. */
  back?: ReactNode;
  /** Optional middle-aligned (e.g. "Skip to Review") action. */
  middle?: ReactNode;
  /** Primary right-aligned (e.g. "Continue to Getty Vocab") action. */
  primary?: ReactNode;
}
export const FooterActions = ({ back, middle, primary }: FooterActionsProps) => (
  <div className="footer-actions">
    {back}
    <span className="spacer" />
    {middle}
    {primary}
  </div>
);
